module.exports = __webpack_public_path__ + "static/media/keep-cool.6362ac38.jpg";